import React from 'react';
import { Box, Typography, Fade } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import DocumentCard from './DocumentCard';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * DocumentList component for displaying search results
 * @param {Object} props - Component props
 * @param {Array} props.documents - Array of document objects
 * @param {Function} props.onDownload - Callback function when download is clicked
 * @param {boolean} props.showEmpty - Whether to show the empty state
 */
const DocumentList = ({ documents, onDownload, showEmpty = false }) => {
  const { t } = useLanguage();
  if (!showEmpty && documents.length === 0) {
    return null;
  }

  if (documents.length === 0) {
    return (
      <Fade in={true}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 6,
            color: 'text.secondary',
          }}
        >
          <SearchOffIcon sx={{ fontSize: 64, mb: 2, opacity: 0.5 }} />
          <Typography variant="h6" gutterBottom>
            {t('noDocuments')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('noDocumentsMessage')}
          </Typography>
        </Box>
      </Fade>
    );
  }

  return (
    <Fade in={true}>
      <Box>
        <Typography
          variant="subtitle1"
          sx={{ mb: 2, color: 'text.secondary', textAlign: 'center' }}
        >
          {t('documentsFound')}: {documents.length}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            justifyContent: 'center',
            maxWidth: '100%',
          }}
        >
          {documents.map((doc) => (
            <Box
              key={doc.id}
              sx={{
                width: {
                  xs: '100%',
                  sm: 'calc(50% - 8px)',
                  md: 'calc(33.333% - 11px)',
                },
                maxWidth: {
                  md: '400px',
                },
              }}
            >
              <DocumentCard
                document={doc}
                onDownload={onDownload}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Fade>
  );
};

export default DocumentList;
